import React, { Component } from 'react';
import { bool, array } from 'prop-types';

import StepperItem from './StepperItem';
import { StepperWrapper, StepperList, MobileScrollWrapper } from './styles';

class Stepper extends Component {
  static propTypes = {
    applicants: array.isRequired, // eslint-disable-line react/forbid-prop-types
    statuses: array.isRequired, // eslint-disable-line react/forbid-prop-types
    collectInformationReady: bool.isRequired,
    LBControlReady: bool.isRequired,
    signReady: bool.isRequired,
    landlordControlReady: bool.isRequired,
    statusBarOpen: bool.isRequired,
    makeSpaceForNotificationBar: bool.isRequired,
  };

  getProfilePictures = (statuses, applicants) => {
    const images = [];
    for (let i = 0; i < statuses.length; i += 1) {
      const status = statuses[i];
      applicants.forEach((applicant) => {
        if (
          applicant.id === status.applicantId &&
          images.indexOf(applicant.profilePicture) === -1
        )
          images.push(applicant.profilePicture); // .profilePicture
      });
    }
    return images;
  };

  render() {
    let informationReadyStatus = 1;
    let lbControlReadyStatus = 2;
    let signReadyStatus = 2;
    let landlordControlReadyStatus = 2;
    let completeStatus = 2;

    if (this.props.collectInformationReady) {
      informationReadyStatus = 0;
      lbControlReadyStatus = 1;

      if (this.props.LBControlReady) {
        lbControlReadyStatus = 0;
        signReadyStatus = 1;

        if (this.props.signReady) {
          signReadyStatus = 0;
          landlordControlReadyStatus = 1;

          if (this.props.landlordControlReady) {
            landlordControlReadyStatus = 0;
            completeStatus = 1;
          }
        }
      }
    }

    const landlord = this.props.statuses.filter(
      (status) => status.status === 'LANDLORD'
    );
    const vetting = this.props.statuses.filter(
      (status) => status.status === 'VETTING'
    );
    const signing = this.props.statuses.filter(
      (status) => status.status === 'SIGNING'
    );
    const gatherInfo = this.props.statuses.filter(
      (status) => status.status === 'GATHER_INFO'
    );

    const landlordImages = this.getProfilePictures(
      landlord,
      this.props.applicants
    );
    const vettingImages = this.getProfilePictures(
      vetting,
      this.props.applicants
    );
    const signingImages = this.getProfilePictures(
      signing,
      this.props.applicants
    );
    const gatherInfoImages = this.getProfilePictures(
      gatherInfo,
      this.props.applicants
    );

    return (
      <MobileScrollWrapper
        makeSpaceForNotificationBar={this.props.makeSpaceForNotificationBar}
        show={this.props.statusBarOpen}>
        <StepperWrapper>
          <StepperList>
            <StepperItem
              title="Samla information"
              status={informationReadyStatus}
              applicantImages={gatherInfoImages}
              first
            />
            <StepperItem
              title={
                window.isBytesansokanSe
                  ? 'Bytesansökan granskar'
                  : 'Lägenhetsbyte granskar'
              }
              status={lbControlReadyStatus}
              applicantImages={vettingImages}
            />
            <StepperItem
              title="Signering"
              status={signReadyStatus}
              applicantImages={signingImages}
            />
            <StepperItem
              title="Hanteras hos hyresvärd"
              status={landlordControlReadyStatus}
              applicantImages={landlordImages}
            />
            <StepperItem title="Bytet genomfört" status={completeStatus} last />
          </StepperList>
        </StepperWrapper>
      </MobileScrollWrapper>
    );
  }
}

export default Stepper;



// WEBPACK FOOTER //
// ./src/components/Stepper/Stepper.js